import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { LinkedService } from './linkedservice';

import { AzureKeyVault } from './key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'AzureML',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureML_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureML_DisplayText)
    ]
})
export class AzureMLLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_Endpoint
    })
    public mlEndpoint: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_APIKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public apiKey: string | AzureKeyVault;

    public enableUpdateResourceEndpoint: boolean = false;

    @Metamodel.attribute({
        display: stringResources.ModelName_AzureMLUpdateResourceEndPoint
    })
    public updateResourceEndpoint?: string;

    public useARMWebService: boolean = false;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID
    })
    public servicePrincipalId: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant
    })
    public tenant: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
